import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import { getResourcePath } from '@finect/front-core/Routes';
export var getLink = function getLink(theme, tag) {
  var isStorefront = !tag.hasOwnProperty('window') || tag.window;
  var resource = getResourcePath(theme, isStorefront ? 'Storefront' : 'Topic', {
    tag: tag.alias
  });
  if (!resource) {
    return undefined;
  }
  var isSPA = resource.pattern.match;
  var link = {
    href: isSPA ? resource.path : resource.superPartnerURL,
    text: "M\xE1s sobre ".concat(tag.name),
    type: isSPA ? 'client' : undefined
  };
  return link;
};